export const lineSeparatorRegex = /\p{Zl}/gu;

// charcode
// [8232]
